export const machineStatus = [
    { value: 'break', label: 'Сломался', color: '#35bd4b' },
  ]